module.exports = __webpack_public_path__ + "static/media/Sun.3132a0b0.png";